module.exports = "https://redage.akamaized.net/src/views/games/other/images/maps/map_5.png";